import { useInvoicePaymentStatusOptions } from "@/hooks/useEnumOptions";

/** Badge du statut de paiement d'une facture (vide pour un statut sans libellé). */
export const InvoicePaymentStatusBadge = ({ status }: { status: string | undefined }) => {
  const invoiceStatusOptions = useInvoicePaymentStatusOptions();
  const invoiceStatus = invoiceStatusOptions.find((el) => el.value === status);

  return (
    <div className="flex items-center justify-center">
      <div
        className={`flex rounded-2xl border px-3 py-1`}
        style={{
          borderColor: invoiceStatus?.borderColor,
          backgroundColor: invoiceStatus?.bgColor,
        }}
      >
        <p
          className={`text-sm text-[${invoiceStatus?.textColor}]`}
          style={{ color: invoiceStatus?.textColor }}
        >
          {invoiceStatus?.label}
        </p>
      </div>
    </div>
  );
};
